module.exports = __webpack_public_path__ + "static/media/Profile_8.3a3a4df3.svg";